module.exports = __webpack_public_path__ + "./docs/img/icon-obj-c.5940359c474743cd44250a969b3bbe04.svg";